import { render } from "./downloadBox.vue?vue&type=template&id=618af36c&scoped=true"
import script from "./downloadBox.vue?vue&type=script&lang=js"
export * from "./downloadBox.vue?vue&type=script&lang=js"

import "./downloadBox.vue?vue&type=style&index=0&id=618af36c&lang=scss&scoped=true"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618af36c"]])

export default __exports__